import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {NotificationsService, SimpleNotificationsModule} from 'angular2-notifications';
import {BootstrapModalModule} from 'ngx-modialog/plugins/bootstrap';
import {Ng2CompleterModule} from 'ng2-completer';
import {BsDatepickerModule, TooltipModule} from 'ngx-bootstrap';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {ChartsModule} from 'ng2-charts';
import {InfohashService} from '../catalogue/infohash/infohash.service';
import {ImageUpdateService} from '../catalogue/image-update/image-update.service';
import {QAService} from '../catalogue/qa/qa.service';
import {TitleRequestsService} from '../catalogue/title-requests/title-requests.service';
import {SchedulingService} from '../catalogue/scheduling/scheduling.service';
import {DiscoveryService} from '../catalogue/discovery/discovery.service';
import {DatePipe} from '@angular/common';
import {ClipboardService} from 'ngx-clipboard';
import {ESDashboardComponent} from './esDashboard.component';
import {ESDashboardService} from './esDashboard.service';


@NgModule({
    declarations: [
        ESDashboardComponent],
    imports: [BrowserModule,
        HttpModule,
        FormsModule,
        SharedModule,
        SimpleNotificationsModule.forRoot(),
        BootstrapModalModule,
        Ng2CompleterModule,
        BsDatepickerModule.forRoot(),
        CollapseModule.forRoot(),
        TooltipModule.forRoot(), ChartsModule],
    providers: [
        ESDashboardService, DatePipe, NotificationsService,
        ClipboardService,
        InfohashService,
        ImageUpdateService,
        QAService, TitleRequestsService,
        SchedulingService,
        DiscoveryService]
})
export class EsDashboardModule {
}



// WEBPACK FOOTER //
// ./src/app/elastic-search-dashboard/esDashboard.module.ts